module.exports = __webpack_public_path__ + "static/step-1.9cac62ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/data/step-1.png
// module id = 2551
// module chunks = 258451423528153